module.exports = __webpack_public_path__ + "img/pic_20180912140233.d4575fea.jpg";